// Presentation copy + imagery for the catalogue categories returned by
// /category/all. Descriptions only restate what Voorent already offers.
const STORAGE = "https://voorent.com/voorent-storage";

// Lifestyle image used by the homepage hero (~100 KB, chosen with LCP in mind).
export const HERO_IMAGE = `${STORAGE}/premium-prod/imperial-grandeur-sofa-2.png`;

const CATEGORY_META = {
  furniture: {
    title: "Furniture for every room",
    short: "Furniture",
    description: "Sofas, beds, wardrobes, study tables and complete room setups, rented monthly.",
    image: `${STORAGE}/product-image/killim-beige-5-seater-sofa-31120191105121336982577.jpg`,
  },
  appliance: {
    title: "Appliances for every lifestyle",
    short: "Appliances",
    description: "ACs, refrigerators, washing machines and daily-use home tech.",
    image: `${STORAGE}/product-image/led-4020191118061420961598.jpg`,
  },
  package: {
    title: "Complete home packages",
    short: "Packages",
    description: "Move-in ready bundles designed for homes, PGs and co-living spaces.",
    image: `${STORAGE}/product-image/Budget_Friendly-Living-Combo-1.png`,
  },
  premium: {
    title: "The premium collection",
    short: "Premium",
    description: "Statement sofas, beds, tables and mattresses on a 12-month plan.",
    image: `${STORAGE}/product-image/L%20shape%20Sofa%20Cum%20Bed%201.jpeg`,
  },
  seasonal: {
    title: "Seasonal essentials",
    short: "Seasonal",
    description: "ACs, coolers, heaters and air purifiers, rented for the season you need them.",
    image: `${STORAGE}/cooler-1.png`,
  },
  "furniture-and-appliances": {
    title: "Furniture and appliances together",
    short: "Furniture & appliances",
    description: "Beds, sofas and wardrobes alongside fridges, washing machines, ACs and TVs — on one monthly plan.",
    image: `${STORAGE}/product-image/killim-beige-5-seater-sofa-31120191105121336982577.jpg`,
  },
  expressDelivery: {
    title: "Express delivery",
    short: "Express",
    description: "Order before 12 PM for same-day delivery, or get it by the next day.",
    image: null,
    cityOnly: "gurgaon",
  },
};

// Header navigation order (matches the existing site navigation).
export const NAV_CATEGORIES = ["furniture", "appliance", "package", "seasonal", "premium"];

export function getCategoryMeta(slug, fallbackName) {
  const meta = CATEGORY_META[slug];
  if (meta) return meta;
  const name = fallbackName || String(slug || "Products").replace(/([a-z])([A-Z])/g, "$1 $2");
  return {
    title: name.charAt(0).toUpperCase() + name.slice(1),
    short: name,
    description: `Browse ${name.toLowerCase()} on rent with flexible monthly plans.`,
    image: null,
  };
}

// Guards junk URLs like "/delhi/:category" or "/delhi/anything": only these six
// slugs exist in the catalogue API (/category/all).
export function isKnownCategory(slug) {
  return Object.prototype.hasOwnProperty.call(CATEGORY_META, slug);
}

export function isCategoryVisible(slug, city) {
  const meta = CATEGORY_META[slug];
  return !meta || !meta.cityOnly || meta.cityOnly === city;
}

export default CATEGORY_META;
